import template from './scriptEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, scriptService, uiService, Script) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onScriptEdit(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                script: _params.script ? angular.copy(_params.script) : Script.blank()
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (script) {
              if (!_.isUuid(script.id)) {
                script.content = script.content.cleanHtml();
                scriptService.createScript(script).then(function (data) {
                  if (data.status) {
                    script.id = data.id;
                    script.isNew = true;
                    ctrl.onFinished({ script: script });
                    uiService.toast({
                      text: {
                        p1: 'Call script',
                        p2: script.getName(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                script.content = script.content.cleanHtml();
                scriptService.updateScript(script).then(function (data) {
                  if (data.status) {
                    ctrl.onFinished({ script: script });
                    uiService.toast({
                      text: {
                        p1: 'Call script',
                        p2: script.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });

          function dialogController($mdDialog, script) {
            this.script = script;
            this.isEditingScript = _.isUuid(script.id);
            this.confirm = function () {
              if (this.script.name !== '') {
                $mdDialog.hide(this.script);
              } else {
                uiService.toast({
                  text: {
                    p1: 'Call Script',
                    p2: 'name',
                    p3: 'is required'
                  },
                  warn: true
                });
              }
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
